import { OmnibarContext, OmnibarEntry } from '../omnibar-interfaces';

export type OmnibarContextFilter = 'all' | 'current' | 'general' | 'administration';

export const administrationGroup = 'Administration';

function isAdministrationEntry(entry: OmnibarEntry) {
  return entry.group === administrationGroup;
}

export function matchesContextFilter(entry: OmnibarEntry, filter: OmnibarContextFilter) {
  if (filter === 'current') return entry.context !== 'none';
  if (filter === 'general') return entry.context === 'none' && !isAdministrationEntry(entry);
  if (filter === 'administration') return isAdministrationEntry(entry);
  return true;
}

export function currentContextFilterLabel(context: OmnibarContext): string | undefined {
  if (context === 'citizen') return 'Borger';
  if (context === 'company') return 'Virksomhed';
  return undefined;
}
